export const HERO_QUERY = `*[_type == "hero"][0]{
  heading, body, ctaLabel, ctaLink
}`;

export const SERVICES_QUERY = `*[_type == "servicesSection"][0]{
  eyebrow, heading,
  "image": { "url": image.asset->url, "alt": imageAlt },
  items[]{ title, description }
}`;

export const PAGE_QUERY = (slug) => `*[_type == "page" && slug.current == "${slug}"][0]{
  _id,
  title,
  sections[]{
    _key,
    ...,
    _type == "heroAlternative" => { "image": image.asset->url },
    _type == "clients" => { "logos": logos[].asset->url },
    _type == "imageGrid" => { "images": images[].asset->url },
    _type == "alternatingImageText" => {
      sections[]{ ..., "image": image.asset->url }
    },
    _type == "servicesCardsSection" => {
      services[]{ ..., "image": image.asset->url }
    },
    _type == "servicesAccordion" => { "image": image.asset->url },
    _type == "gallery" => {
      items[]{ ..., "image": image.asset->url }
    }
  }
}`;
